import React, { useEffect, useState } from 'react';
import { Loader2, Save } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { IITH } from '@/pages/landing/iithBrand';
import { bookingConfigApi } from '../api/bookingConfig.api';
import ClinicBookingConfigForm from './ClinicBookingConfigForm';

const EMPTY = {
  booking_mode: 'slots',
  slot_minutes: 15,
  max_appointments_per_day: 40,
  max_walkins_per_day: 0,
  patient_book_hours_prior: 2,
  patient_cancel_hours_prior: 4,
};

/** Booking rules section — own load + save. */
export default function ClinicBookingConfigSection() {
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    bookingConfigApi.get()
      .then((b) => setForm({ ...EMPTY, ...b }))
      .catch((e) => toast.error(e?.response?.data?.detail || 'Could not load booking settings'))
      .finally(() => setLoading(false));
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      setForm(await bookingConfigApi.update(form));
      toast.success('Booking settings saved');
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Could not save booking settings');
    }
    setSaving(false);
  };

  if (loading) {
    return <div className="py-12 text-center text-zinc-500"><Loader2 className="h-5 w-5 animate-spin inline" /></div>;
  }

  return (
    <div className="space-y-4" data-testid="booking-config-section">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div>
          <h3 className="text-base font-semibold text-[#071B34]">Booking rules</h3>
          <p className="text-sm text-[#5A6B7C] mt-0.5">
            Online OPD mode, slot length, daily caps, and patient timing. Walk-in 0 = unlimited.
          </p>
        </div>
        <Button onClick={save} disabled={saving} style={{ background: IITH.saffron }}
          className="text-white" data-testid="booking-section-save">
          {saving ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : <Save className="h-4 w-4 mr-2" />}
          Save booking
        </Button>
      </div>
      <ClinicBookingConfigForm form={form} setForm={setForm} />
    </div>
  );
}
